export const calcLeft = (value, min, max, margin = 9) => `calc(${margin}px + ${((value - min) / (max - min))} * calc(100% - ${margin * 2}px))`;
export const SLIDER_TRACK_HEIGHT_VAR = '--slider-track-height';
export const sliderRootClassNames = [
    '@relative',
    '@w-full',
    '@touch-none',
    '@select-none',
    '[&>[style^="transform"]]:@z-10',
];
export const sliderTrackClassNames = [
    '@flex',
    '@items-center',
    '@relative',
    '@h-2.5',
    '@w-full',
    '@grow',
    '@overflow-hidden',
    '@rounded-full',
    '@bg-grey-2',
    // '@border',
    // '@border-grey-2_3',
    'before:@absolute',
    'before:@w-full',
    'before:@h-full',
    'before:@rounded-full',
    'before:@border',
    'before:@border-grey-2_3',
];
export const sliderRangeClassNames = [
    '@absolute',
    '@h-full',
    '@bg-brand1-1'
];
export const sliderThumbClassNames = [
    '@relative',
    '@flex',
    '@items-center',
    '@justify-center',
    '@top-[calc(-9px-var(--slider-track-height)/2)]',
    '@h-[18px]',
    '@w-[18px]',
    '@rounded-full',
    '@border',
    '@border-grey-2_5',
    '@bg-grey-1',
    '@z-10',
    'before:@w-3',
    'before:@h-3',
    'before:@rounded-full',
    'before:@bg-brand1-1',
    '@drop-shadow-md',
    '@ring-offset-background',
    '@transition-colors',
    'focus-visible:@outline-none',
    // 'focus-visible:@ring-2',
    // 'focus-visible:@ring-ring',
    // 'focus-visible:@ring-offset-2',
    'disabled:@pointer-events-none',
    'disabled:@opacity-50'
];
export const sliderThumbVueClassNames = [
    ...sliderThumbClassNames,
    '@top-[calc(-9px+var(--slider-track-height)/2)]',
];
export const sliderScaleContainerClassNames = [
    '@mt-0.5',
    '@mb-1',
    '@mx-2',
    '@h-1',
];
export const sliderScaleItemClassNames = [
    '@absolute',
    '@w-px',
    '@h-1',
    '@bg-grey-4',
];
export const sliderLabelContainerClassNames = [
    '@h-[18px]',
];
export const sliderLabelItemClassNames = [
    '@text-grey-5',
    '@text-caption',
    '@absolute',
    '@-translate-x-1/2',
];
